import * as ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfiguration from './payments-payins-configurations-v1-payins-configuration-payins-configurations.http.js';
import * as ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes from './payments-payins-configurations-v1-payins-configuration-payins-configurations.types.js';
import * as ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes from './payments-payins-configurations-v1-payins-configuration-payins-configurations.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createPayinsConfiguration(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.CreatePayinsConfigurationRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.CreatePayinsConfigurationRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.CreatePayinsConfigurationResponse,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.CreatePayinsConfigurationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfiguration.createPayinsConfiguration(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payins-configurations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPayinsConfiguration(): __PublicMethodMetaInfo<
  'GET',
  { payinsConfigurationId: string },
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.GetPayinsConfigurationRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.GetPayinsConfigurationRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.GetPayinsConfigurationResponse,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.GetPayinsConfigurationResponse
> {
  const payload = { payinsConfigurationId: ':payinsConfigurationId' } as any;

  const getRequestOptions =
    ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfiguration.getPayinsConfiguration(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/payins-configurations/{payinsConfigurationId}',
    pathParams: { payinsConfigurationId: 'payinsConfigurationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePayinsConfiguration(): __PublicMethodMetaInfo<
  'PATCH',
  { payinsConfigurationId: string },
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.UpdatePayinsConfigurationRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.UpdatePayinsConfigurationRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.UpdatePayinsConfigurationResponse,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.UpdatePayinsConfigurationResponse
> {
  const payload = {
    payinsConfiguration: { id: ':payinsConfigurationId' },
  } as any;

  const getRequestOptions =
    ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfiguration.updatePayinsConfiguration(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/payins-configurations/{payinsConfiguration.id}',
    pathParams: { payinsConfigurationId: 'payinsConfigurationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryPayinsConfigurations(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.QueryPayinsConfigurationsRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.QueryPayinsConfigurationsRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.QueryPayinsConfigurationsResponse,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.QueryPayinsConfigurationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfiguration.queryPayinsConfigurations(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/payins-configurations/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdatePayinsConfigurationTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.BulkUpdatePayinsConfigurationTagsRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.BulkUpdatePayinsConfigurationTagsRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.BulkUpdatePayinsConfigurationTagsResponse,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.BulkUpdatePayinsConfigurationTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfiguration.bulkUpdatePayinsConfigurationTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/payins-configurations/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdatePayinsConfigurationTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.BulkUpdatePayinsConfigurationTagsByFilterRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.BulkUpdatePayinsConfigurationTagsByFilterRequest,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationUniversalTypes.BulkUpdatePayinsConfigurationTagsByFilterResponse,
  ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfigurationTypes.BulkUpdatePayinsConfigurationTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsPayinsConfigurationsV1PayinsConfiguration.bulkUpdatePayinsConfigurationTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/payins-configurations/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  PayinsConfiguration as PayinsConfigurationOriginal,
  PayinsRule as PayinsRuleOriginal,
  MerchantSelection as MerchantSelectionOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  CreatePayinsConfigurationRequest as CreatePayinsConfigurationRequestOriginal,
  CreatePayinsConfigurationResponse as CreatePayinsConfigurationResponseOriginal,
  GetPayinsConfigurationRequest as GetPayinsConfigurationRequestOriginal,
  GetPayinsConfigurationResponse as GetPayinsConfigurationResponseOriginal,
  UpdatePayinsConfigurationRequest as UpdatePayinsConfigurationRequestOriginal,
  UpdatePayinsConfigurationResponse as UpdatePayinsConfigurationResponseOriginal,
  QueryPayinsConfigurationsRequest as QueryPayinsConfigurationsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryPayinsConfigurationsResponse as QueryPayinsConfigurationsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkUpdatePayinsConfigurationTagsRequest as BulkUpdatePayinsConfigurationTagsRequestOriginal,
  BulkUpdatePayinsConfigurationTagsResponse as BulkUpdatePayinsConfigurationTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdatePayinsConfigurationTagsResult as BulkUpdatePayinsConfigurationTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdatePayinsConfigurationTagsByFilterRequest as BulkUpdatePayinsConfigurationTagsByFilterRequestOriginal,
  BulkUpdatePayinsConfigurationTagsByFilterResponse as BulkUpdatePayinsConfigurationTagsByFilterResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
} from './payments-payins-configurations-v1-payins-configuration-payins-configurations.types.js';
